<template lang="pug">
v-app
  header.site-header(itemscope itemtype="https://schema.org/WPHeader")
    .wrap
      #top-links.clearfix
        div
          a.logo(href="https://www.arlingtonva.us/")
            | arlingtonva.us
          .holder-inner(style="min-height:53px")
  v-main
    Index
  footer.site-footer(itemtype="//schema.org/WPFooter" itemscope="itemscope" role="contentinfo")
    .holder
      img.logo(width="140" height="70" alt="Arlington County logo" src="//d1rn8z435cu2eh.cloudfront.net/img/bottom-arlington-logo-2x.png")
      ul.social-media-icons
        li
          a.icon-twitter(title="Twitter" href="https://twitter.com/arlingtonva")
        li
          a.icon-facebook(title="Facebook" href="https://www.facebook.com/ArlingtonVA")
        li
          a.icon-flickr(title="Flickr" href="https://secure.flickr.com/photos/arlingtonva/")
        li
          a.icon-youtube(title="YouTube" href="https://www.youtube.com/user/arlingtoncounty")
        li
          a.icon-rss(title="RSS" href="http://newsroom.arlingtonva.us/category/news-releases/feed/")
      ul.other-links
        li.first
          a(title="Arlington County homepage" href="http://www.arlingtonva.us/") County Homepage
        li
          a(title="Terms and Conditions" href="http://www.arlingtonva.us/terms-conditions/") Terms &amp; Conditions
        li
          a(title="Global sitemap" href="http://www.arlingtonva.us/global-sitemap/") Global Sitemap
        li
          a(title="For Employees" href="http://www.arlingtonva.us/employees/") For Employees
        li
          a(title="Contact Arlington County" href="https://www.arlingtonva.us/contact-arlington/") Contact Arlington
      small Copyright © {{new Date().getFullYear()}} Arlington County Government
</template>

<script>
import Index from "./components/Index";
import store from "./store";

export default {
  name: "App",
  store,

  components: {
    Index,
  },

  data: () => ({
    //
  }),
};
</script>

<style lang="stylus">$body-font-family = 'Open Sans', Arial, sans-serif;

div.acgdig-left[role='tab'] {
  justify-content: flex-end;
}

.v-toolbar .v-btn__content {
  color: white;
}

html {
  scroll-behavior: smooth;
}

$acg-blue: #005cbb, $acg-light-blue: #2e8be8, $acg-grey: #666, $link-hover: #7ac4fc, #top-links {
  display: flex;
  justify-content: center;
  padding-left: 16px;
  padding-right: 16px;

  > div {
    margin: 0 auto;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .logo {
    position: relative;

    i {
      position: relative;
      top: 8px;
    }
  }

  .holder-inner {
    font-size: 1rem;
    color: white;
  }
}

@media all and (min-width: 960px) {
  #top-links > div {
    max-width: 852px;
  }
}

@media all and (min-width: 1264px) {
  #top-links > div {
    max-width: 1137px;
  }
}

@media all and (min-width: 1904px) {
  #top-links > div {
    max-width: 1737px;
  }
}

.bull {
  margin: 0 5px 0 5px;
  padding: 0 5px 0 5px;
}

table {
  border: 0px;
}

th {
  font-size: 14px !important;
}

th, td {
  vertical-align: middle;
}

tr:first-child {
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
  font-weight: bold;
}

tr:first-child td {
  font-weight: normal;
}

tr:nth-child(odd) {
  background-color: #fff;
}

.acg-big {
  font-size: 1.3em !important;
}

.acg-small {
  font-size: 13px !important;
}

h1.acg-heading {
  color: black;
}

h2.acg-subheading {
  color: black;
  font-size: 3.2em;
}

div.v-calendar-weekly__day-label, div.v-calendar-weekly__day-month {
  font-size: 0.9rem;
}

.card-heading {
  color: #015cb9;
  font-size: 18px;
  margin: 0;
}

.card-subheading {
  color: #717171;
  font-size: 14px;
  margin: 0;
}

.card-spacer {
  height: 10px;
}

.card-text {
  font-size: 13px;
  margin: 0;
}

.btn-card:hover {
  background-color: #CFD8DC;
}

.btn-card .title {
  color: #0277BD;
}

.btn-card {
  padding: 10px;
}

footer small {
  font-size: 10px;
}
</style>
